export const MODAL_MODES = {
  SIGN_IN: 'SIGN_IN',
  REGISTRATION: 'REGISTRATION',
  REGISTRATION_SUCCESS: 'REGISTRATION_SUCCESS',
  PASSWORD_RECOVERY: 'PASSWORD_RECOVERY',
  PASSWORD_RECOVERY_SUCCESS: 'PASSWORD_RECOVERY_SUCCESS',
};
